import deepmerge from 'deepmerge';
import { useMemo } from 'react';

const defaultOptions = {
  arrayMerge: (_: never, sourceArray: unknown[]) => [...sourceArray],
};

export const useDeepMerge = <T1, T2>(
  object1: Partial<T1>,
  object2: Partial<T2>,
  options?: deepmerge.Options | 'overwriteArray' | undefined,
): T1 & T2 => {
  // eslint-disable-next-line @typescript-eslint/init-declarations
  let myOptions: deepmerge.Options | undefined;

  if (options === 'overwriteArray') {
    myOptions = defaultOptions;
  } else {
    myOptions = options;
  }

  return (useMemo(
    () => deepmerge( object1, object2, myOptions ),
    [
      object1,
      object2,
      myOptions,
    ],
  ));
};

type ObjectArrayType<T extends object[]> = T extends Array<infer U> ? U extends object ? U
  : never
  : never;

export const useDeepMergeAll = <T extends object[]>(
  objectArray: Array<ObjectArrayType<T>>,
  options?: deepmerge.Options | 'overwriteArray' | undefined,
): ObjectArrayType<T> => {
  // eslint-disable-next-line @typescript-eslint/init-declarations
  let myOptions: deepmerge.Options | undefined;

  if (options === 'overwriteArray') {
    myOptions = defaultOptions;
  } else {
    myOptions = options;
  }

  return (useMemo(
    () => deepmerge.all<ObjectArrayType<T>>( objectArray, myOptions ),
    [
      objectArray,
      myOptions,
    ],
  ));
};
